export type VideoPollState = "ready" | "processing" | "failed" | "expired" | "stalled";

export const VIDEO_POLL_INTERVAL_MS = 5000;
export const VIDEO_POLL_MAX_MS = 30 * 60 * 1000;

const TERMINAL = new Set(["ready", "error", "expired"]);

export function videoPollExpired(startedAt: number | null | undefined, now: number = Date.now()): boolean {
  return typeof startedAt === "number" && now - startedAt >= VIDEO_POLL_MAX_MS - VIDEO_POLL_INTERVAL_MS;
}

export function isTerminalVideoStatus(status: string | null | undefined): boolean {
  return TERMINAL.has(String(status || "").toLowerCase());
}

export function videoPollState({
  status,
  checkFailed = false,
  startedAt = null,
  now = Date.now(),
}: {
  status: string | null | undefined;
  checkFailed?: boolean;
  startedAt?: number | null;
  now?: number;
}): VideoPollState {
  const s = String(status || "").toLowerCase();
  if (s === "ready") return "ready";
  if (s === "error") return "failed";
  if (s === "expired") return "expired";
  if (checkFailed) return "stalled";
  if (videoPollExpired(startedAt, now)) return "stalled";
  return "processing";
}

export function videoProblemMessage(state: VideoPollState, errorMessage?: string | null): string | null {
  if (state === "failed") {
    return errorMessage ? `Meta could not process this video: ${errorMessage}` : "Meta could not process this video. Upload a different file";
  }
  if (state === "expired") return "This video upload expired on Meta. Upload it again";
  if (state === "stalled") return "Couldn't confirm Meta finished processing this video. Upload it again or try later";
  return null;
}
